'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Badge = require('wix-ui-backoffice/Badge');

exports.default = _Badge.Badge;